<template>
  <O3D>
    <O3D :key="item._id" v-for="item in buildList">
      <TextClicker v-if="item.name === building" :py="item.labelY" @clicker="$emit('edit')" :text="item.displayName"></TextClicker>
      <component v-if="item.name === building" :is="item.component"></component>
    </O3D>
    <slot></slot>
  </O3D>
</template>

<script>
import { O3DG2 } from '../../../Reusable/O3DG2'
import { Buildings } from  '../Buildings'
let list = new Buildings()
export default {
  props: {
    building: {}
  },
  mixins: [O3DG2],
  data () {
    return {
      buildList: list.list
    }
  },
  async mounted () {
  }
}
</script>

<style>
</style>
